export default "__VITE_ASSET__XcBKcgcA__"